import Table from './Table';

export type { ITableProps } from './Table.types';
export default Table;
